<i id="icon" class="{{ data.icon }} s-modal__icon"></i>
<span id="title" class="title s-modal__text">{{ data.title | translate }}</span>
<button id="action" class="btn btn-flat btn-auto s-modal__btn" *ngIf="data.action" (click)="dismiss()">
  {{ data.action | translate }}
</button>
